/**
 * User Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type AuthMethodType = 'Password' | 'PasscodeSms' | 'PasscodeEmail' | 'StaticCode' | 'SoftToken' | 'HardwareToken' | 'Yubikey' | 'Fido';

export const AuthMethodType = {
    Password: 'Password' as AuthMethodType,
    PasscodeSms: 'PasscodeSms' as AuthMethodType,
    PasscodeEmail: 'PasscodeEmail' as AuthMethodType,
    StaticCode: 'StaticCode' as AuthMethodType,
    SoftToken: 'SoftToken' as AuthMethodType,
    HardwareToken: 'HardwareToken' as AuthMethodType,
    Yubikey: 'Yubikey' as AuthMethodType,
    Fido: 'Fido' as AuthMethodType
};

